import React from 'react'
import { useTranslation } from 'react-i18next'
import {Typography} from 'antd'
import classNames from 'classnames'
import {paginationOptions} from '@/services/mocks'
import {Select} from '@/components'
import {useScreenType} from '@/hooks'
import {PaginationOptionsSelectProps} from './props'
import styles from './styles.scss'
import {PAGINATION_LABEL, PAGINATION_SELECTED} from '@/constants/playwright-ids'

export const PageSizeSelect: React.FC<PaginationOptionsSelectProps> = ({
    total,
    className,
    pageSize,
    onChange
}) => {
    const { t } = useTranslation()
    const {isMobile, isTablet} = useScreenType()

    const renderOutOfTotal = () =>
        pageSize < total ? (
            <span className={styles.outOfTotal}>
                {t('PageSizeSelect.of')} {total}
            </span>
        ) : null

    return (
        <div
            className={classNames(styles.pagination, className, {
                [styles.paginationMobile]: isMobile
            })}
        >
            <span className={styles.paginationLabel} data-test-id={PAGINATION_LABEL}>
                {isMobile || isTablet ? (
                    <Typography.Text type={'secondary'}>{t('PageSizeSelect.items')}:</Typography.Text>
                ) : (
                    t('PageSizeSelect.itemsOnAPage')
                )}
            </span>
            <Select
                data-test-id={PAGINATION_SELECTED}
                variant={'borderless'}
                value={pageSize}
                defaultValue={paginationOptions[2]}
                placeholder={t('PageSizeSelect.select')}
                options={paginationOptions}
                onChange={onChange}
            />
            {isMobile || isTablet ? null : renderOutOfTotal()}
        </div>
    )
}
